import React from 'react';
import { ErrorPage } from '../../common/components/ui/ErrorPage/ErrorPage';

export default function NotFoundPage() {
  return <ErrorPage title="Страница не найдена" />;
}
